import axios from "axios";
import { API_BASE_URL } from "../../../constants/apiConstants";
import { saveEncryptedDataToSessionStorage } from "../../../utils";
import { SECRET_KEY } from "../../../constants/encriptKey";

export const loginDoctor = (payload) => {
  return new Promise((resolve, reject) => {
    axios
      .post(`${API_BASE_URL}Medicos/loginMedico`, payload, {
        headers: {
          Accept: "application/json, text/plain, */*",
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        if (res.data.status !== "Error") {
          // localStorage.setItem("idUsuario", res.data.result.idUsuario);
          // localStorage.setItem("idMedico", res.data.result.idMedico);
          // localStorage.setItem("nombre", res.data.result.nombre);
          // localStorage.setItem("apellido", res.data.result.apellido);
          // localStorage.setItem("especialidad", res.data.result.especialidad);
          // localStorage.setItem("tipoMatricula", res.data.result.tipoMatricula);
          // localStorage.setItem("nroMatricula", res.data.result.nroMatricula);
          // localStorage.setItem("nroDocumento", res.data.result.nroDocumento);
          // localStorage.setItem("email", res.data.result.email);
          // localStorage.setItem("token", res.data.result.token);
          // localStorage.setItem("estado", res.data.result.estado);
          // localStorage.setItem("accessToken", res.data.result.accessToken);
          console.log("Login exitoso:", res.data.result);
          saveEncryptedDataToSessionStorage({...res.data.result}, SECRET_KEY)
          resolve({ ...res.data.result, payload });
        } else {
          reject(res.data);
        }
      })
      .catch((err) => {
        reject(
          err.response
            ? err.response.data
            : "NO SE PUEDE INGRESAR EN ESTE MOMENTO. INTÉNTELO MÁS TARDE"
        );
      });
  });
};
